/** In-memory APNS device token — registered before auth, POSTed once session is active. */
let storedApnsToken: string | null = null;

export function setStoredApnsToken(token: string | null): void {
  storedApnsToken = token;
}

export function getStoredApnsToken(): string | null {
  return storedApnsToken;
}
